<template>
  <l-rich class="showText" v-if="disabled && printMode" v-model="value"/>
  <div v-else
      v-loading="loading" 
      :element-loading-text="$t('图片上传中...')"
      element-loading-spinner="el-icon-loading"
      class="cl-editor-quill"
      style="position: relative;"
      >
    <div ref="Editor" class="learun-editor" id="Editor" :style="style"></div>
    <l-dialog
      v-if="isLearunFramework"
      :title="$t('图片空间')"
      :visible.sync="dialogVisible"
      :height="650"
      :width="1080"
      :hasBtns="false"
    >
      <l-img-space
        ref="imgSpace"
        @confirm="handleConfirm"
      ></l-img-space>
    </l-dialog>
    <at-dg ref="atDg" v-if="showDialog" :position="atPosition" :atKeyword="atKeyword" :users="users"
      @onPickUser="handlePickUser" @onHide="handleHide" @onShow="handleShow"></at-dg>
    <emojiDg ref="emojiDg" v-if="showEmoji" :position="emojiPosition" @insertEmoji="insertEmoji"
     ></emojiDg>
  </div>
</template>
<script>
import Quill from "./myQuill";
import "quill/dist/quill.snow.css";
import chatScreen from './editor.js'
import atDg from './atDg'
import emojiDg from './emojiDg'
import resizeImage from 'quill-image-resize-module' // 图片缩放组件引用
// import { ImageDrop } from 'quill-image-drop-module'; // 图片拖动组件引用
// Quill.register('modules/imageDrop', ImageDrop); // 注册
Quill.register('modules/resizeImage ', resizeImage ) // 注册
export default {
  name: "l-editor",
  components: {
    atDg,
    emojiDg
  },
  props: {
    value: {},
    options: Object,
    placeholder: String,
    disabled: Boolean,
    height: [String, Number],
    isUploadImg:{
      type:Boolean,
      default:true
    },
    isCanFullScreen: {
      default: true
    },
    users: {
      default: () => {
        return []
      }
    },
    userNameKey: {
      default: 'userName'
    },
    userValueKey: {
      default: 'f_UserId'
    },
    toolbar: {
      default: ''
    },
    printMode: {
      default: false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.setContent(newVal);
      },
      immediate: true,
    },
  },
  computed: {
    style() {
      const height = this.$isNumber(this.height)
        ? this.height + "px"
        : this.height;

      return {
        height,
      }
    },
    isLearunFramework() {
      if(!this.isUploadImg){
        return false
      }
      if (this.lr_chunkedUpload) {
        return true
      }
      return false
    },
  },
  data() {
    return {

      showEmoji: false,
      myEditor: '',
      quill: null,
      content: "",
      loading:false,
      dialogVisible: false,
      atKeyword: '',
      showDialog: false,
      atPosition: {
        x: 0,
        y: 0
      },
      emojiPosition: {
        x: 0,
        y: 0
      }
    };
  },
  mounted() {
    let that = this
    let fontFamily = [
      "SimSun",
      "Microsoft-YaHei",
      "SimHei",
      "FangSong",
      "KaiTi",
      "Lishu",
      "Youyuan",
      "Pingfang",
      "Arial",
      "ComicSansMs",
      "CourierNew",
      "Tahoma",
      "TimesNewRoman",
      "Verdana",
    ];
    Quill.imports["formats/font"].whitelist = fontFamily;
    Quill.register(Quill.imports["formats/font"]);

    // 自定义文字大小
    let fontSize = [
      "12px",
      "13px",
      "14px",
      "15px",
      "16px",
      "18px",
      "20px",
      "24px",
      "36px",
    ];
    Quill.imports["attributors/style/size"].whitelist = fontSize;
    Quill.register(Quill.imports["attributors/style/size"]);
    // 实例化
  let container = this.toolbar || [
      [
        "bold",
        "italic", 
        "underline", 
        "strike", 
        "blockquote", 
        "code-block",
        { list: "ordered" },
        { list: "bullet" },
        { script: "sub" },
        { script: "super" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] },
        { color: [] },
        { background: [] },
        { font: fontFamily },
        { size: fontSize },
        { header: [1, 2, 3, 4, 5, 6, false] },
        "link", 
        "image",
        'emoji'
      ],
      // //[{ header: 1 }, { header: 2 }],
      // [
      //   { list: "ordered" },
      //   { list: "bullet" },
      //   { script: "sub" },
      //   { script: "super" },
      //   { indent: "-1" },
      //   { indent: "+1" },
      //   { align: [] },
      // ],
      // //[{ direction: "rtl" }],
      // [
      //   { color: [] },
      //   { background: [] },
      //   { font: fontFamily },
      //   { size: fontSize },
      //   { header: [1, 2, 3, 4, 5, 6, false] },
      // ],

      // ///["clean"],
      // ["link", "image"],
      // ['fullscreen']
    ]
    if (this.isCanFullScreen) container[0].push('fullscreen')
    this.quill = new Quill(this.$refs.Editor, {
      theme: "snow",
      placeholder: this.placeholder,
      readOnly: this.disabled,
      modules: {
        // imageDrop: true,      //图片拖拽
        imageResize: {          //放大缩小
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        },
        fullscreen: {},
        emoji: {},
        toolbar: {
          container,
          handlers: {
            fullscreen() {  
                this.quill.getModule('fullscreen').handle()
            },
            emoji() {
              that.showEmoji = !that.showEmoji
              let info = that.getElementPos(document.querySelector('.emoji')) 
              that.emojiPosition = {
                x: info.x - 322,
                y: info.y - 250 > 0 ? info.y - 250 : info.y + 20
              }

              console.log(that.emojiPosition,"that.emojiPosition===============")
              // this.quill.getModule('emoji').handle()
            },
          }
        },
        keyboard: {
          bindings: {
            enter: {
              key: 13,
              handler: () => {
                if (this.showDialog) return
                let quill = this.quill
                // 获取编辑器光标位置
                let length = quill.selection.savedRange.index
                // 插入图片至光标位置，look为图片地址
                quill.insertText(length, `\n`)
                // 移动光标至图片后面
                quill.setSelection(length + 1)
              }
            }
          }
        }
      },
      ...this.options,
      
    });

    this.setContent(this.value);
    this.content = this.value;

    // 监听输入
    this.quill.on("text-change", () => {
      let value = this.quill.root.innerHTML

      // 图片需要做一次转化
      if(this.apiUrl){
        const delta = this.quill.getContents()
        const len = delta.ops.length
        for(let i = 0;i < len;i++){
          const deltaItem = delta.ops[i]
          if(deltaItem.insert && deltaItem.insert.image && deltaItem.insert.image.indexOf(this.apiUrl) > -1){
            const imageUrl = `${deltaItem.insert.image.replace(this.apiUrl + 'system/annexesfile/','{learun_img_api}').replace('token=' + this.token,'{learun_img_token}')}`
            value = value.replace(deltaItem.insert.image,imageUrl)
          }
        }
      }
      
      value = value.replace(/token=\S+\"/g, '{learun_img_token}"')
      this.content = value
      this.$emit("input", value)
      this.$emit("change", value)
    });
    this.quill.on("selection-change", (range) => {
      if(!range) {
        this.getblur()
      }
    });
    this.imgInit()
    // 加载回调
    this.$emit("load", this.quill)
    this.initBtn()
    this.initEmoji()
    this.myEditor = new chatScreen(this.quill)
  },
  methods: {
    getblur() {
      this.showEmoji = false
      console.log(this.showEmoji,"this.showEmoji==============")
    },
    initBtn () {
      const editorButton = document.querySelector('.ql-fullscreen')
      if (!editorButton) return
      editorButton.innerHTML = '<i class="learun-icon-unfold full" style="font-size: 14px;color: black"></i><i class="learun-icon-narrow unfull" style="font-size: 14px;color: black;display:none"></i>'

    },
    initEmoji () {

      const editorButton = document.querySelector('.ql-emoji')
      if (!editorButton) return
      editorButton.innerHTML = '<i class="learun-icon-icon emoji" style="font-size: 14px;color: black"></i>'

    },
    setContent(val) {
      if (this.quill) {
        if (this.content != val) {

          // 图片格式转化
          val = val || ""
          val = val.replace(/{learun_img_api}/g,`${this.apiUrl}system/annexesfile/`)
          .replace(/{learun_img_token}/g,`token=${this.token}`)
          this.content = val

          this.quill.root.innerHTML = val || ""
        }
      }
    },

    /// 图片处理
    imgInit() {
      if(this.isLearunFramework) {
        this.quill
          .getModule("toolbar")
          .addHandler("image", this.uploadImgHandler)
        this.quill.root.addEventListener("paste", this.pasteHandle, false)
        this.quill.root.addEventListener("blur", this.handleHide, false)
        this.quill.root.addEventListener("keydown", this.keydownHandle, false)
        this.quill.root.addEventListener("keyup", this.keyupHandle, false)
        this.quill.root.addEventListener('drop', this.dropHandle, false)
        this.quill.root.addEventListener('dropover', (e) => {
          e.preventDefault()
        }, false)
      }
    },
    keyupHandle (e) {
      if (this.myEditor.showAt() && this.users.length) {
        this.atPosition = this.myEditor.getRangeRect()
        this.atKeyword = this.myEditor.getAtUser()
        this.showDialog = true
      } else {
        this.showDialog = false
      }
    },
    keydownHandle (e) {
      console.log(e.keyCode,"e.keyCode==========================")
      if (this.showDialog && ['Escape', 'ArrowDown', 'ArrowUp', 'Enter'].includes(e.code)) {
        e.preventDefault()
        e.stopPropagation()
        this.$refs.atDg && this.$refs.atDg.keyDownHandler(e)
        return
      }
     
      if (e.keyCode == 27 && document.querySelector('.editor-fullscreen')) {
        this.quill.getModule('fullscreen').handle()
      }
    },
    pasteHandle(e) {
      let clipboardData = e.clipboardData
      let i = 0
      let items, item, types

      if (clipboardData) {
        items = clipboardData.items

        if (!items) {
          return
        }
        item = items[0];
        types = clipboardData.types || [];

        for (; i < types.length; i++) {
          if (types[i] === "Files") {
            item = items[i]
            break
          }
        }
        if (item && item.kind === "file" && item.type.match(/^image\//i)) {
          let file = item.getAsFile()
          if(this.isLearunFramework){
            this.uploadImg(file)
          }
          else{
            this.toBase64(file)
          }
          e.preventDefault()
        }
      }
    },
    dropHandle(e){
      e.preventDefault()
      const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象
      if(this.isLearunFramework){
        this.uploadImg(file)
      }
      else{
        this.toBase64(file)
      }
    },
    toBase64(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
          this.insertImg(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    uploadImg(file){
      const option = {
        file:file,
        data:{
          folderId:this.$uuid()
        }
      }
      this.lr_chunkedUpload(option,async(data)=>{
        const api = window.$api.system.img
        const url = await this.$awaitWraper(api.upload('learun_img',data))
        if(url){
          this.insertImg(`${this.apiUrl}system/annexesfile/${url}?token=${this.token}`)
          return {
            data:{
              code:200
            }
          }
        }
        else{
          return {
            data:{
              code:400
            }
          }
        }
      })
    },
    insertImg(imgURL) {
      let length = (this.quill.getSelection() || {}).index || this.quill.getLength()
      this.quill.insertEmbed(length, 'image', imgURL,Quill.sources.USER)
      this.quill.update()
      this.quill.setSelection(length+1)
    },


    uploadImgHandler() {
      this.dialogVisible = true;
    },


    handleConfirm(data) {
      let length = (this.quill.getSelection() || {}).index || this.quill.getLength()
      data.forEach((item,i) => {
        this.quill.insertEmbed(length + i, 'image', `${this.apiUrl}system/annexesfile/${item.f_Id}?token=${this.token}`,Quill.sources.USER)
      })
      this.quill.update()
      this.quill.setSelection(length + data.length)
      this.dialogVisible = false
    },
    // 插入标签后隐藏选择框
    handlePickUser({type, user}) {
      this.myEditor.replaceAtUser(user, {id: user[this.userValueKey], name: user[this.userNameKey]}, this.atKeyword, type)
      this.showDialog = false
    },
    insertEmoji({str,src}) {
      console.log(str,"str========================")
      this.myEditor.insertEmoji({str,src})
      this.showEmoji = false
      console.log(this.myEditor,"this.myEditor=====================")
    },
    handleHide() {
      setTimeout(() => {
        this.showDialog = false
      }, 150);
    },
    handleShow() {
      this.showDialog = true
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
:-webkit-full-screen #Editor {
  width: 100%;
  height: 100%;
}
.editor-fullscreen{
  background: white;
  margin: 0 !important;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100% !important;
  z-index: 100000;
  .unfull {
    display: inline-block !important;
  }
  .full {
    display: none !important;;
  }
  .cl-editor-quill {
    height: 100% !important;
  }
}
.ql-fullscreen{
    display: flex !important;
    align-items: center;
    i:hover {
      color: #06c !important
    }
}
.ql-emoji{
    display: flex !important;
    align-items: center;
    i:hover {
      color: #06c !important
    }
}
.editor-fullscreen {
  .ql-container {
    height: calc(100% - 42px) !important;
  }
}
</style>